export const GET_XP = 'GET_XP'
export const GET_STARS = 'GET_STARS'
export const GET_VOUCHERS = 'GET_VOUCHERS'
export const GET_DIFFICULTIES = 'GET_DIFFICULTIES'
export const GETXP_GRADES = 'GETXP_GRADES'
export const GET_LEVELS = 'GET LEVELS'
